import { render, staticRenderFns } from "./HistoryBox.vue?vue&type=template&id=c4bc7324&scoped=true"
import script from "./HistoryBox.vue?vue&type=script&lang=js"
export * from "./HistoryBox.vue?vue&type=script&lang=js"
import style0 from "./HistoryBox.vue?vue&type=style&index=0&id=c4bc7324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bc7324",
  null
  
)

export default component.exports